module.exports = __webpack_public_path__ + "static/media/image_9.91124541.png";